import VehicleSpeicifactions from "./VehicleSpecifications";

export default VehicleSpeicifactions;
